<template>
  <div class="heading">
    <div class="cover">
      <div class="ahead">
        {{ ahead }}
      </div>
      <div class="behind">
        {{ behind }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Heading",
  props: {
    ahead: {
      type: String,
      required: true
    },
    behind: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped>
.heading {
  width: 100%;
  padding: 5px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.cover {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: center;
  width: 100px;
  border-bottom: 3px solid #029aff;
}

.ahead {
  font-size: 5em;
  text-transform: capitalize;
  font-family: "Sacramento", Calibri, Candara, Arial, Helvetica, sans-serif;
  position: relative;
  z-index: 2;
}

.ahead:hover {
  color: #1fa2fa;
}

.behind {
  color: rgba(0, 0, 0, 0.09);
  font-size: 3em;
  font-weight: bolder;
  text-transform: capitalize;
  font-family: "Comfortaa", cursive, Arial, Helvetica, sans-serif;
  transform: translateX(-20%);
  position: relative;
  z-index: 1;
}
</style>

<style scoped>
@media screen and (max-width: 850px) {
  .ahead {
    font-size: 4em;
  }

  .behind {
    font-size: 2em;
    transform: translate(-15%, -20%);
  }
}
</style>
